import { render, staticRenderFns } from "./ProductPlayer.vue?vue&type=template&id=837c5064&scoped=true&"
import script from "./ProductPlayer.vue?vue&type=script&lang=js&"
export * from "./ProductPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlayer.vue?vue&type=style&index=0&id=837c5064&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837c5064",
  null
  
)

export default component.exports